import axios from '@/axios'

const actions = {
  setCategories: ({ commit, state }) => {
    if (state.categories.length) return Promise.resolve() // referência estática: busca 1x
    return axios
      .categories
      .fetch(
        '/categories'
      )
      .then((response) => {
        commit('categories', response)
      })
  }
}

export default actions
